import colors from '../../_shared/colors';

export const GlobalInserts = `
  .ant-menu-horizontal > .ant-menu-item::after,
  .ant-menu-horizontal > .ant-menu-item-selected::after,
  .ant-menu-horizontal > .ant-menu-item-active::after,
  .ant-menu-horizontal > .ant-menu-item:hover::after {
    border-bottom-width: 5px !important;
    width: 100%;
    left: 0 !important;
  }

  .ant-menu-horizontal > .ant-menu-item {
    font-size: 14px;
  }
`;

export const ellipsis = {
  container: `
    display: flex;
    flex-direction: row;
    margin-left: auto;
    margin-right: 10px;
  `,
  dropContainer: `
    margin-right: 10px;
  `,
  a: `
    transform: rotate(90deg);
    color: ${colors.black};
    font-size: 30px;
    font-weight: bold;
  `,
  menuItem: `
    font-size: 14px;
  `,
  menuIcon: `
    margin-right: 10px;
  `,
};

export default {
  container: `
    display: flex;
    flex-direction: row;
    height: 50px;
    background-color: ${colors.lightBackground};
    line-height: 48px;
    padding: 0;
    border-bottom: 2px solid ${colors.inputBorder};
  `,
  /* AER-1465: Input.Search's container in antd v6 stretches to fill the
     remaining flex space in the header, which collides with the user name.
     Force a hard max-width on the component itself plus its inner wrappers
     (v3 and v6 markup) so the search bar stays a fixed size. */
  search: `
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1 1 auto;
    max-width: 500px;
    margin-left: auto;
    margin-right: 10px;

    &.ant-input-search,
    & .ant-input-wrapper.ant-input-group,
    & .ant-input-affix-wrapper {
      max-width: 500px;
    }

    .ant-input-search-icon,
    .ant-input-search-icon::before,
    .anticon-search {
      color: ${colors.highlight};
    }

    .ant-input-search-icon::after {
      border-left-color: ${colors.highlight};
    }
  `,
  pbContainer: `
    display: flex;
    flex-direction: row;
    height: 50px;
    background-color: ${colors.lightBackground};
    line-height: 48px;
    padding: 0;
    border-bottom: 2px solid ${colors.inputBorder};
    align-items: center;
    justify-content: space-between;
    position: relative;
  `,
  pbFilterButton: `
    padding: 0 14px;
    font-size: 20px;
    cursor: pointer;
    color: ${colors.black};
    display: flex;
    align-items: center;
    height: 100%;
  `,
  pbLogoWrap: `
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
  `,
  menuContainer: `
    display: flex; 
    flex-direction: row; 
    height: 50px; 
    min-width: 550px;
  `,
  menu: `width: 100%;`
};
